import React from 'react';
import withApollo from 'next-with-apollo';
import { ApolloProvider } from '@apollo/client';
import { createApolloClient, getApolloClient } from './client';

/**
 * Always creates a new apollo client on the server so that data
 * isn't shared between connections.
 * Creates or reuses apollo client in the browser.
 */
export default withApollo(
    ({ initialState, headers }) => {
        const isBrowser = typeof window !== 'undefined';

        const client = isBrowser
            ? getApolloClient(initialState, headers)
            : createApolloClient(initialState, headers);

        return client;
    },
    {
        render: function withApolloProvider({ Page, props }) {
            return (
                <ApolloProvider client={props.apollo}>
                    <Page {...props} />
                </ApolloProvider>
            );
        }
    }
);
